import React, { FC } from "react";
import RatesModal from "containers/retail/sections/energy-rates-3/RatesModal";
import Title from "evcharging/components/Title";
import Spacer from "evcharging/components/Spacer";
import { Plan } from "services/quotes/types";
import RatesPlanDetails from "containers/retail/sections/energy-rates-3/RatesPlanDetails";
import Button from "evcharging/components/Button";
import useI18n from "evcharging/hooks/useI18n";

export interface RatesMobileDetailsModalProps {
  onClose: () => void;
  show: boolean;
  plan: Plan;
  onSelectPlan: () => void;
}

const RatesMobileDetailsModal: FC<RatesMobileDetailsModalProps> = (props) => {
  const { onClose, show, plan, onSelectPlan } = props;

  const { t } = useI18n();

  return (
    <RatesModal open={show} onClose={onClose}>
      <Title variant={"p"} fontSize={28}>{t('rates.more-plan-details')}</Title>
      <Spacer value={12} />

      <RatesPlanDetails plan={plan} />
      <Spacer value={12} />
      <Button fullWidth onClick={onSelectPlan}>{t('rates.select-plan')}</Button>
    </RatesModal>
  );
};

export default RatesMobileDetailsModal;
